export default __webpack_public_path__ + "a2b5e876f1ae9e5d0f9b507164e0ff97.png";